import {Model, ModelMixin} from '../../common/model.class';
import {WorkDuration} from '../../common/values/work-duration.class';

export type Statuses = 'Active' | 'Honorable/Discharge' | 'Dishonorable/Discharge';

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
export class MilitaryExperience extends ModelMixin() implements Model<MilitaryExperience> {

    TYPE = MilitaryExperience;

    public branch: string;
    public status?: Statuses;
    public duration: WorkDuration = new WorkDuration();

    constructor(jsonData: any = {}) {
        super();
        if (jsonData.duration) jsonData.duration = new WorkDuration(jsonData.duration);
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/work/military/military-experience.model.ts